import type { FC } from 'react';
import { useSportItemsCount, useSportUrlParams } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { routes } from '@/constants';
import type { ChampionshipItemProps } from './ChampionshipItem.types';
import styles from './ChampionshipItem.module.scss';
export const ChampionshipItem: FC<ChampionshipItemProps> = ({
  analytics,
  item,
  isActive
}) => {
  const {
    createChampionshipLink,
    stage
  } = useSportUrlParams({
    routes
  });
  const count = useSportItemsCount({
    linesCount: item.linesCount,
    stage,
    isOutrightInTotalEnabled: true
  });
  const href = createChampionshipLink(item);
  return <div className={styles.root} data-sentry-component="ChampionshipItem" data-sentry-source-file="ChampionshipItem.tsx">
      <Button className={cn(styles.item, {
      [styles.active]: isActive
    })} key={item.id} as="link" href={href} align="left" variant="text" shallow fullWidth analytics={analytics} data-sentry-element="Button" data-sentry-source-file="ChampionshipItem.tsx">
        <span className={styles.title}>{item.title}</span>
        <span className={styles.count}>{count}</span>
      </Button>
    </div>;
};